/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonChangeOfobject,
    JsonChangeOfobjectFromJSON,
    JsonChangeOfobjectFromJSONTyped,
    JsonChangeOfobjectToJSON,
} from './JsonChangeOfobject';

/**
 * 
 * @export
 * @interface JsonFile
 */
export interface JsonFile {
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonFile
     */
    allowedActions?: Array<JsonFileAllowedActionsEnum>;
    /**
     * 
     * @type {Array<JsonChangeOfobject>}
     * @memberof JsonFile
     */
    changes?: Array<JsonChangeOfobject>;
    /**
     * 
     * @type {string}
     * @memberof JsonFile
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonFile
     */
    createdBy?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonFile
     */
    cvResult?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonFile
     */
    eventId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonFile
     */
    eventPartyId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonFile
     */
    eventPartyTravelId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonFile
     */
    fileId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonFile
     */
    fileName?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonFile
     */
    fileSize?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonFile
     */
    fileType?: JsonFileFileTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof JsonFile
     */
    guid?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonFile
     */
    hash?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonFile
     */
    mimeType?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonFile
     */
    partyId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonFile
     */
    status?: JsonFileStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof JsonFile
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonFile
     */
    updatedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonFile
     */
    updatedBy?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonFile
     */
    userId?: number;
}

/**
* @export
* @enum {string}
*/
export enum JsonFileAllowedActionsEnum {
    View = 'VIEW',
    Edit = 'EDIT'
}/**
* @export
* @enum {string}
*/
export enum JsonFileFileTypeEnum {
    Photo = 'PHOTO',
    Image = 'IMAGE',
    Attachment = 'ATTACHMENT',
    Travel = 'TRAVEL',
    Contract = 'CONTRACT'
}/**
* @export
* @enum {string}
*/
export enum JsonFileStatusEnum {
    Deleted = 'DELETED',
    Active = 'ACTIVE',
    PendingOk = 'PENDING_OK',
    PendingWarn = 'PENDING_WARN'
}

export function JsonFileFromJSON(json: any): JsonFile {
    return JsonFileFromJSONTyped(json, false);
}

export function JsonFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonFile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowedActions': !exists(json, 'allowedActions') ? undefined : json['allowedActions'],
        'changes': !exists(json, 'changes') ? undefined : ((json['changes'] as Array<any>).map(JsonChangeOfobjectFromJSON)),
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'cvResult': !exists(json, 'cvResult') ? undefined : json['cvResult'],
        'eventId': !exists(json, 'eventId') ? undefined : json['eventId'],
        'eventPartyId': !exists(json, 'eventPartyId') ? undefined : json['eventPartyId'],
        'eventPartyTravelId': !exists(json, 'eventPartyTravelId') ? undefined : json['eventPartyTravelId'],
        'fileId': !exists(json, 'fileId') ? undefined : json['fileId'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'fileSize': !exists(json, 'fileSize') ? undefined : json['fileSize'],
        'fileType': !exists(json, 'fileType') ? undefined : json['fileType'],
        'guid': !exists(json, 'guid') ? undefined : json['guid'],
        'hash': !exists(json, 'hash') ? undefined : json['hash'],
        'mimeType': !exists(json, 'mimeType') ? undefined : json['mimeType'],
        'partyId': !exists(json, 'partyId') ? undefined : json['partyId'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
    };
}

export function JsonFileToJSON(value?: JsonFile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowedActions': value.allowedActions,
        'changes': value.changes === undefined ? undefined : ((value.changes as Array<any>).map(JsonChangeOfobjectToJSON)),
        'createdAt': value.createdAt,
        'createdBy': value.createdBy,
        'cvResult': value.cvResult,
        'eventId': value.eventId,
        'eventPartyId': value.eventPartyId,
        'eventPartyTravelId': value.eventPartyTravelId,
        'fileId': value.fileId,
        'fileName': value.fileName,
        'fileSize': value.fileSize,
        'fileType': value.fileType,
        'guid': value.guid,
        'hash': value.hash,
        'mimeType': value.mimeType,
        'partyId': value.partyId,
        'status': value.status,
        'title': value.title,
        'updatedAt': value.updatedAt,
        'updatedBy': value.updatedBy,
        'userId': value.userId,
    };
}

